import yall from 'yall-js'

const prImg = ()=>{
  document.addEventListener("DOMContentLoaded", yall);
}
export default prImg



